/**
 * Vertical bar charts (Dates / Users bandwidth tabs) — KPI-aligned steel blues + indigo/violet accents.
 * @see bandwidthKpiTableChrome header #4472C4 / #2F5597
 */

const VERTICAL_BAR_PALETTE = [
  'rgba(47, 85, 151, 0.92)',
  'rgba(68, 114, 196, 0.9)',
  'rgba(59, 130, 246, 0.88)',
  'rgba(99, 102, 241, 0.86)',
  'rgba(129, 140, 248, 0.84)',
  'rgba(139, 92, 246, 0.82)',
] as const;

export function bandwidthVerticalBarPalette(index: number): string {
  return VERTICAL_BAR_PALETTE[index % VERTICAL_BAR_PALETTE.length]!;
}

/** Strong bar when a slice is selected (drill). */
export const bandwidthVerticalBarSelected = 'rgba(30, 64, 125, 0.98)';

/** Non-selected bars when another slice is selected. */
export const bandwidthVerticalBarDim = 'rgba(68, 114, 196, 0.26)';
